import axios from "@/axios";
// eslint-disable-next-line import/no-cycle
import BasicAuthService from "./basicAuthService";

const basicAuth = new BasicAuthService(axios, localStorage);
export default basicAuth;
